module.exports = __webpack_public_path__ + "img/logo (3).2bf06b0d.png";